/**
 * @generated SignedSource<<b93efb2000435f29a454de3eae9af2a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AboManager_component$data = {
  readonly changesbuttontext: string | null | undefined;
  readonly id: string;
  readonly priceinfo: {
    readonly checked: boolean;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PriceInfo_component">;
  } | null | undefined;
  readonly subscriptiontable: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"AboTable_table">;
  } | null | undefined;
  readonly " $fragmentType": "AboManager_component";
};
export type AboManager_component$key = {
  readonly " $data"?: AboManager_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"AboManager_component">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "salesAdmission",
  "variableName": "salesAdmission"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "retailOnly"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesAdmission"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AboManager_component",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "retailOnly",
          "variableName": "retailOnly"
        },
        (v1/*: any*/)
      ],
      "concreteType": "SubscriptionTable",
      "kind": "LinkedField",
      "name": "subscriptiontable",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AboTable_table"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v1/*: any*/)
      ],
      "concreteType": "PriceInfo",
      "kind": "LinkedField",
      "name": "priceinfo",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checked",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PriceInfo_component"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "changesbuttontext",
      "storageKey": null
    }
  ],
  "type": "SubscriptionManager",
  "abstractKey": null
};
})();

(node as any).hash = "9a20ab39733f7c36113e1278bab9c7a7";

export default node;
